import { useRef } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'

const DeinformationForm = ({ navigation, route }: any): JSX.Element => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
  } = params

  const intializeStore = useInitializeStore()
  const { postdeonline, loading } = useFormsStore()

  const personalstore = usePersonalStore()

  const options1 = [
    { key: 1, value: 1 },
    { key: 2, value: 2 }
  ]

  const options2 = [
    { key: 1, value: 'Resident withholding allowance(s) computation worksheet' },
    { key: 2, value: 'Non-Resident withholding allowance(s) computation worksheet' }
  ]
  const options3 = [
    { key: 1, value: 0 },
    { key: 2, value: 1 },
    { key: 3, value: 2 }
  ]

  const options4 = [
    {
      key: 1, value: 'No',
    },
    {
      key: 2, value: "Yes"
    }
  ]

  const options5 = [
    { key: 1, value: "Single" },
    { key: 2, value: "Married" }
  ]

  function resetresident(props) {

    props.setFieldValue('claimsyouasadependent', "")
    props.setFieldValue('claimsyourspouseasadependent', "")
    props.setFieldValue('noofdependentsexceptspouse', "")
    props.setFieldValue('childdependentcarecredit', "")
    props.setFieldValue('over65orblind', "")
    props.setFieldValue('spouseover65orblind', "")
    props.setFieldValue('receivenonwageincome', "")
    props.setFieldValue('itemizedDeductions', "")
    props.setFieldValue('alimonypaid', "")
    props.setFieldValue('nonwageincome', "")
  }
  function resetnonresident(props) {

    props.setFieldValue('claimforyourself', "")
    props.setFieldValue('claimforspouse', "")
    props.setFieldValue('noofdependents', "")
    props.setFieldValue('Wages', "")
    props.setFieldValue('nonwages', "")
    props.setFieldValue('federaladjustments', "")
    props.setFieldValue('delwareadjustmensts', "")
    props.setFieldValue('deductions', "")
    props.setFieldValue('noofpayperiod', "")

  }

  const intialValues = {
    taxpayerid: "",
    totalnoofdependents: "",
    additionalamount: "",
    residentornonresident: "",
    claimsyouasadependent: "",
    claimsyourspouseasadependent: "",
    noofdependentsexceptspouse: "",
    childdependentcarecredit: "",
    over65orblind: "",
    spouseover65orblind: "",
    receivenonwageincome: "",
    itemizedDeductions: "",
    alimonypaid: "",
    nonwageincome: "",
    claimforyourself: '',
    claimforspouse: '',
    noofdependents: '',
    Wages: '',
    nonwages: '',
    federaladjustments: '',
    delwareadjustmensts: '',
    deductions: '',
    noofpayperiod: '',
    maritalStatus: ""
  }
  const w4schema = () => {
    const baseSchema = {

      // taxpayerid: yup.string().required("Tax payer id is a required field"),
      totalnoofdependents: yup.string().required("Total no of dependents is a required field"),
      additionalamount: yup.string().required("Additional amount is a required field"),


      residentornonresident: yup.string().required("Resident or Not a resident is a required field"),
      claimsyouasadependent: yup.string().when("residentornonresident", (residentornonresident: any, schema) => {
        if (residentornonresident == 1) {
          return schema.required("Claims you  as a dependent is a required field")
        }
        return schema.nullable()
      }),
      claimsyourspouseasadependent: yup.string().when(["residentornonresident", "maritalStatus"], ([residentornonresident, maritalStatus]: any, schema) => {
        if (residentornonresident == 1 && Number(maritalStatus) === 1) {
          return schema.required("Claims your spouse as a dependent is a required field")
        }
        return schema.nullable()
      }),
      noofdependentsexceptspouse: yup.string().when("residentornonresident", (residentornonresident: any, schema) => {
        if (residentornonresident == 1) {
          return schema.required("No of dependents except spouse  is a required field")
        }
        return schema.nullable()
      }),
      childdependentcarecredit: yup.string().nullable()
      ,
      over65orblind: yup.string().when("residentornonresident", (residentornonresident: any, schema) => {
        if (residentornonresident == 1) {
          return schema.required("Are you over 65 or blind  is a required field")
        }
        return schema.nullable()
      }),
      spouseover65orblind: yup.string().when("residentornonresident", (residentornonresident: any, schema) => {
        if (residentornonresident == 1) {
          return schema.required("Is your spouse over 65 or blind  is a required field")
        }
        return schema.nullable()
      }),
      receivenonwageincome: yup.string().when("residentornonresident", (residentornonresident: any, schema) => {
        if (residentornonresident == 1) {
          return schema.required("Do you recieve non-wage income is a required field")
        }
        return schema.nullable()
      }),

      itemizedDeductions: yup.string().when("receivenonwageincome", (receivenonwageincome: any, schema) => {
        if (receivenonwageincome == 1) {
          return schema.required("Itemized deductions is a required field")
        }
        return schema.nullable()
      }),
      alimonypaid: yup.string().when("receivenonwageincome", (receivenonwageincome: any, schema) => {
        if (receivenonwageincome == 1) {
          return schema.required("Alimony paid is a required field")
        }
        return schema.nullable()
      }),
      nonwageincome: yup.string().when("receivenonwageincome", (receivenonwageincome: any, schema) => {
        if (receivenonwageincome == 1) {
          return schema.required("Non wage income is a required field")
        }
        return schema.nullable()
      }),

      claimforyourself: yup
        .string().when("residentornonresident", (residentornonresident: any, schema) => {
          if (residentornonresident == 2) {
            return schema.required("Claim yourself  is a required field")
          }
          return schema.nullable()
        }),
      claimforspouse: yup
        .string().when("residentornonresident", (residentornonresident: any, schema) => {
          if (residentornonresident == 2) {
            return schema.required("Claim for Spouse  is a required field")
          }
          return schema.nullable()
        }),
      noofdependents: yup
        .string().when("residentornonresident", (residentornonresident: any, schema) => {
          if (residentornonresident == 2) {
            return schema.required('Number of dependent is a required field')
          }
          return schema.nullable()
        }),
      Wages: yup
        .string()
        .when("residentornonresident", (residentornonresident: any, schema) => {
          if (residentornonresident == 2) {
            return schema.required('Wages is a required field')
          }
          return schema.nullable()
        }),
      nonwages: yup
        .string()
        .when("residentornonresident", (residentornonresident: any, schema) => {
          if (residentornonresident == 2) {
            return schema.required('Non-Wages Income is a required field')
          }
          return schema.nullable()
        })
      ,
      federaladjustments: yup
        .string()
        .when("residentornonresident", (residentornonresident: any, schema) => {
          if (residentornonresident == 2) {
            return schema.required('Fedral Adjustments is a required field')
          }
          return schema.nullable()
        })
      ,
      delwareadjustmensts: yup
        .string()
        .when("residentornonresident", (residentornonresident: any, schema) => {
          if (residentornonresident == 2) {
            return schema.required('Delware Adjustments is a required field')
          }
          return schema.nullable()
        })
      ,
      deductions: yup
        .string()
        .when("residentornonresident", (residentornonresident: any, schema) => {
          if (residentornonresident == 2) {
            return schema.required('Deductions is a required field')
          }
          return schema.nullable()
        })
      ,
      noofpayperiod: yup
        .string()
        .when("residentornonresident", (residentornonresident: any, schema) => {
          if (residentornonresident == 2) {
            return schema.required('Number of Payperiod is a required field')
          }
          return schema.nullable()
        }),

      maritalStatus: yup.string().required("Marital status is a required field")

    }


    return yup.object(baseSchema)
  }
  const schema = w4schema()

  let grossTaxliability
  function calculatePayWithTable(x: number) {
    const taxTable = [
      { min: 0, max: 2000, basePay: 0, rate: 0.00, overAmount: 0 },
      { min: 2001, max: 5000, basePay: 0, rate: 0.022, overAmount: 2000 },
      { min: 5001, max: 10000, basePay: 66.00, rate: 0.039, overAmount: 5000 },
      { min: 10001, max: 20000, basePay: 261.00, rate: 0.048, overAmount: 10000 },
      { min: 20001, max: 25000, basePay: 741.00, rate: 0.052, overAmount: 20000 },
      { min: 25001, max: 60000, basePay: 1041.00, rate: 0.0555, overAmount: 25000 },
      { min: 60001, max: Infinity, basePay: 2943.50, rate: 0.066, overAmount: 60000 },
    ];

    for (let i = 0; i < taxTable.length; i++) {
      const { min, max, basePay, rate, overAmount } = taxTable[i];
      if (x >= min && x <= max) {
        // Updated formula with additional parentheses
        return (
          grossTaxliability = (basePay + ((x - overAmount) * rate)).toFixed(2)
        )
      }
    }
    return "0.00"; // Default if no range matches
  }


  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'DE Withholding Taxation'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={schema}
          onSubmit={async (values, actions) => {

            let gtotal = null;
            let deductions3 = null;
            let deductions5 = null;
            let deductions7 = null;
            let deductions8 = null;
            let deductions10 = null;

            if (Number(values?.residentornonresident) == 1) {

              gtotal = Number(values?.claimsyouasadependent) + Number(values?.claimsyourspouseasadependent) + Number(values?.noofdependentsexceptspouse) + Number(values?.childdependentcarecredit) + Number(values?.over65orblind) + Number(values?.spouseover65orblind)
            }

            if (Number(values?.receivenonwageincome) == 1) {
              deductions3 = Math.max(Number(values.itemizedDeductions) - 3250, 0)
              deductions5 = deductions3 + Number(values?.alimonypaid)
              deductions7 = Math.abs(Number(values?.nonwageincome) - deductions5)
              deductions8 = deductions7 / 2000
              deductions10 = deductions8 + gtotal
            }

            const totalAtoC = Number(values.claimforyourself) + Number(values.claimforspouse) + Number(values.noofdependents)
            const totalincome = Number(values.Wages) + Number(values.nonwages)
            const totaladjustments = Number(values.federaladjustments) + Number(values.delwareadjustmensts)
            const adjustgrossincome = Math.abs(totalincome - totaladjustments)
            const propotionaldecimal = adjustgrossincome
            const estimatedTaxableincome = Math.abs(adjustgrossincome - Number(values.deductions))
            calculatePayWithTable(estimatedTaxableincome)
            const personalcredits = totalAtoC * 110
            const netLiability = Math.abs(grossTaxliability - personalcredits)
            const estimatedTaxliability = netLiability * propotionaldecimal
            const withholdingpayperiod = estimatedTaxliability / Number(values.noofpayperiod) || 1

            const data = {
              entityId: personalstore.personalData?.entityId,
              essUserKey: intializeStore.initializeData?.userkey,
              essObKey: essUserOnBoardingKey,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              completeOnline: mode === 'upload' ? false : true,
              // taxpayerid: values?.taxpayerid,
              totalNoOfDependents: values?.totalnoofdependents,
              additionalAmount: values?.additionalamount,
              residentOrNonresident: values?.residentornonresident,
              claimsYouAsADependent: values?.claimsyouasadependent ? values?.claimsyouasadependent : null,
              claimsYourSpouseAsADependent: values.claimsyourspouseasadependent ? values.claimsyourspouseasadependent : null,
              noOfDependentsExceptSpouse: values?.noofdependentsexceptspouse ? values?.noofdependentsexceptspouse : null,
              childDependentCareCredit: values?.childdependentcarecredit ? values?.childdependentcarecredit : null,
              over65OrBlind: values?.over65orblind ? values?.over65orblind : null,
              spouseOver65OrBlind: values.spouseover65orblind ? values.spouseover65orblind : null,
              gTotal: gtotal,
              receiveNonwageIncome: values?.receivenonwageincome ? values?.receivenonwageincome : null,
              itemizedDeductions: values?.itemizedDeductions ? values?.itemizedDeductions : null,
              deductions3: deductions3,
              alimonyPaid: values?.alimonypaid ? values?.alimonypaid : null,
              deductions5: deductions5,
              nonwageIncome: values?.nonwageincome ? values?.nonwageincome : null,
              deductions7: deductions7,
              deductions8: deductions8,
              deductions10: deductions10,
              claimForYourself: values?.claimforyourself ? values?.claimforyourself : null,
              claimForSpouse: values?.claimforspouse ? values?.claimforspouse : null,
              noOfDependents: values?.noofdependents ? values?.noofdependents : null,
              totalAToC: totalAtoC,
              wages: values?.Wages ? values?.Wages : null,
              nonwages: values?.nonwages ? values?.nonwages : null,
              totalIncome: totalincome,
              federalAdjustments: values?.federaladjustments ? values?.federaladjustments : null,
              delawareAdjustments: values?.delwareadjustmensts ? values?.delwareadjustmensts : null,
              totalAdjustments: totaladjustments,
              adjustedGrossIncome: adjustgrossincome,
              proportionalDecimal: propotionaldecimal,
              deductions: values?.deductions ? values?.deductions : null,
              estimatedTaxableIncome: estimatedTaxableincome,
              grossTaxLiability: grossTaxliability,
              personalCredits: personalcredits,
              netLiability: netLiability,
              estimatedTaxLiability: estimatedTaxliability,
              noOfPayPeriod: values?.noofpayperiod ? values?.noofpayperiod : null,
              withholdingPayPeriod: withholdingpayperiod,
              maritalStatus: values?.maritalStatus
            }

            const response = await postdeonline(data)
            if (response?.success) {
              if (mode === 'online') {
                navigation.navigate('Deonline', {
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                  completeOnline: mode === 'upload' ? false : true,
                  deductions3,
                  deductions5,
                  deductions7,
                  deductions8,
                  deductions10,
                  totalAtoC,
                  totalincome,
                  adjustgrossincome,
                  propotionaldecimal,
                  estimatedTaxableincome,
                  grossTaxliability,
                  personalcredits,
                  netLiability,
                  estimatedTaxliability,
                  gtotal,
                  totaladjustments,
                  withholdingpayperiod
                })
              } else {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }



          }}
        >
          {(props) => (
            <>
              <Card>

                {/* <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Enter Taxpayer ID *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.taxpayerid}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('taxpayerid')(text)
                        }
                      }}
                    />

                    {props.touched.taxpayerid &&
                      props.errors.taxpayerid && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.taxpayerid as string}
                        </Text>
                      )}
                  </View>
                </View> */}


                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        'Marital Status *'
                      }
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: "hidden" }}>
                    <SelectKeyValue
                      title="Marital Status"
                      options={options5}
                      selectedOption={mapSelectValue(
                        options5,
                        props.values.maritalStatus
                      )}
                      onSelect={(option: any) => {
                        const newStatus = option - 1
                        props.setFieldValue('maritalStatus', newStatus)
                        if (newStatus === 0) {
                          props.setFieldValue('claimsyourspouseasadependent', "")
                        }
                      }}
                      textColor="primary"
                    />
                    {props.touched.maritalStatus && props.errors.maritalStatus && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.maritalStatus as string}
                      </Text>
                    )}
                  </View>
                </View>


                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '68%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Total number of dependents you can claim on your return*'}
                    </Text>

                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[
                        globalStyles.input,
                        globalStyles.inputLight
                      ]}
                      value={props.values.totalnoofdependents}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('totalnoofdependents')(
                            text
                          )
                        }
                      }}
                    />
                    {props.touched.totalnoofdependents &&
                      props.errors.totalnoofdependents && (
                        <Text style={globalStyles.dangerAlert}>
                          {
                            props.errors.totalnoofdependents as string
                          }
                        </Text>
                      )}
                  </View>

                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '68%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Additional amount, if any, you want withheld from each paycheck *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.additionalamount}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('additionalamount')(text)
                        }
                      }}
                    />

                    {props.touched.additionalamount &&
                      props.errors.additionalamount && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.additionalamount as string}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '68%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Would you like to claim withholding as a resident or a non-resident*'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Would you like to claim withholding as a resident or a non-resident."
                      options={options2}
                      selectedOption={mapSelectValue(
                        options2,
                        props.values.residentornonresident
                      )}
                      onSelect={(option: any) => {
                        if (option == 1) {
                          resetnonresident(props)

                        }
                        else {
                          resetresident(props)
                        }
                        props.setFieldValue('residentornonresident', option)

                      }}
                      textColor="primary"
                    />
                    {props.touched.residentornonresident &&
                      props.errors.residentornonresident && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.residentornonresident as string}
                        </Text>
                      )}
                  </View>
                </View>
                {(Number(props.values.residentornonresident) == 1) &&
                  <>
                    <View style={{ alignItems: 'center' }}>
                      <Text
                        style={[
                          globalStyles.text,
                          globalStyles.fwBold,
                          globalStyles.fs15,
                          globalStyles.blackTextColor
                        ]}
                      >
                        {'RESIDENT WITHHOLDING ALLOWANCE(S'}
                      </Text>
                    </View>

                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center', width: '68%' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'select “1” for Yourself (2 if 60 years old or older) if no one else claims you as a dependent*'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <SelectKeyValue
                          title="select “1” for Yourself (2 if 60 years old or older) if no one else claims you as a dependent."
                          options={options1}
                          selectedOption={mapSelectValue(
                            options1,
                            props.values.claimsyouasadependent
                          )}
                          onSelect={(option: any) => {
                            props.setFieldValue('claimsyouasadependent', option)

                          }}
                          textColor="primary"
                        />
                        {props.touched.claimsyouasadependent &&
                          props.errors.claimsyouasadependent && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.claimsyouasadependent as string}
                            </Text>
                          )}
                      </View>
                    </View>

                    {props.values.maritalStatus !== 0 && props.values.maritalStatus !== '0' && (
                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View style={{ justifyContent: 'center', width: '68%' }}>
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {'select “1” for your Spouse (2 if 60 years old or older) if no one else claims your spouse as a dependent*'}
                          </Text>
                        </View>
                        <View style={{ width: '28%', overflow: 'hidden' }}>
                          <SelectKeyValue
                            title="select “1” for Yourself (2 if 60 years old or older) if no one else claims you as a dependent."
                            options={options1}
                            selectedOption={mapSelectValue(
                              options1,
                              props.values.claimsyourspouseasadependent
                            )}
                            onSelect={(option: any) => {
                              props.setFieldValue('claimsyourspouseasadependent', option)

                            }}
                            textColor="primary"
                          />
                          {props.touched.claimsyourspouseasadependent &&
                            props.errors.claimsyourspouseasadependent && (
                              <Text style={globalStyles.dangerAlert}>
                                {props.errors.claimsyourspouseasadependent as string}
                              </Text>
                            )}
                        </View>
                      </View>
                    )}

                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center', width: '68%' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'Enter number of dependents other than your spouse that you will claim*'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <TextInput
                          style={[globalStyles.input, globalStyles.inputLight]}
                          value={props.values.noofdependentsexceptspouse}
                          keyboardType="numeric"
                          onChangeText={(text) => {
                            if (text === '' || /^\d+$/.test(text)) {
                              props.handleChange('noofdependentsexceptspouse')(text)
                            }
                          }}
                        />

                        {props.touched.noofdependentsexceptspouse &&
                          props.errors.noofdependentsexceptspouse && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.noofdependentsexceptspouse as string}
                            </Text>
                          )}
                      </View>
                    </View>

                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center', width: '68%' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'select “1” if you qualify to take a child/dependent care credit for one child or dependent and “2” if you qualify to take the credit for two or more '}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <SelectKeyValue
                          title="select “1” if you qualify to take a child/dependent care credit for one child or dependent and “2” if you qualify to take the credit for two or more"
                          options={options1}
                          selectedOption={mapSelectValue(
                            options1,
                            props.values.childdependentcarecredit
                          )}
                          onSelect={(option: any) => {
                            props.setFieldValue('childdependentcarecredit', option)

                          }}
                          textColor="primary"
                        />
                        {props.touched.childdependentcarecredit &&
                          props.errors.childdependentcarecredit && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.childdependentcarecredit as string}
                            </Text>
                          )}
                      </View>
                    </View>

                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center', width: '68%' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'select “1” if you are 65 or over OR blind. Enter “2” if you are both 65 or over AND blind.Enter “0” if none of these apply to you.*'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <SelectKeyValue
                          title="select “1” if you are 65 or over OR blind. Enter “2” if you are both 65 or over AND blind..Enter “0” if none of these apply to you.*"
                          options={options3}
                          selectedOption={
                            props.values.over65orblind
                          }
                          onSelect={(option: any) => {
                            console.log("key", option - 1)
                            props.setFieldValue('over65orblind', option - 1)

                          }}
                          textColor="primary"
                        />
                        {props.touched.over65orblind &&
                          props.errors.over65orblind && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.over65orblind as string}
                            </Text>
                          )}
                      </View>
                    </View>

                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center', width: '68%' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'select  “1” if your spouse is 65 or older OR blind. Enter “2” if your spouse is 65 or older AND blind.Enter “0” if none of these apply to you.*'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <SelectKeyValue
                          title="select  “1” if your spouse is 65 or older OR blind. Enter “2” if your spouse is 65 or older AND blind.Enter “0” if none of these apply to you."
                          options={options3}
                          selectedOption={
                            props.values.spouseover65orblind
                          }
                          onSelect={(option: any) => {
                            console.log("key", option - 1)
                            props.setFieldValue('spouseover65orblind', option - 1)

                          }}
                          textColor="primary"
                        />
                        {props.touched.spouseover65orblind &&
                          props.errors.spouseover65orblind && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.spouseover65orblind as string}
                            </Text>
                          )}
                      </View>
                    </View>

                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center', width: '68%' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'Do you plan to itemize, receive non-wage income, or claim other deductions and wish to adjust your withholding ?*'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <SelectKeyValue
                          title="Do you plan to itemize, receive non-wage income, or claim other deductions and wish to adjust your withholding?"
                          options={options4}
                          selectedOption={mapSelectValue(
                            options4,
                            props.values.receivenonwageincome
                          )}
                          onSelect={(option: any) => {

                            props.setFieldValue('receivenonwageincome', option - 1)

                          }}
                          textColor="primary"
                        />
                        {props.touched.receivenonwageincome &&
                          props.errors.receivenonwageincome && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.receivenonwageincome as string}
                            </Text>
                          )}
                      </View>
                    </View>

                    {(Number(props.values?.receivenonwageincome) == 1 &&
                      <>

                        <View style={{ alignItems: 'center' }}>
                          <Text
                            style={[
                              globalStyles.text,
                              globalStyles.fwBold,
                              globalStyles.fs15,
                              globalStyles.blackTextColor
                            ]}
                          >
                            {'DEDUCTIONS AND INCOME ADJUSTMENTS'}
                          </Text>
                        </View>

                        <View
                          style={[
                            globalStyles.hDirection,
                            globalStyles.hBetweenItems,
                            globalStyles.mb2
                          ]}
                        >
                          <View style={{ justifyContent: 'center', width: '68%' }}>
                            <Text
                              style={[
                                globalStyles.inputLabel,
                                globalStyles.inputLabelLarge,
                                globalStyles.inputLabelPrimary
                              ]}
                            >
                              {'Enter an estimate of your itemized deductions for the current year*'}
                            </Text>
                          </View>
                          <View style={{ width: '28%', overflow: 'hidden' }}>
                            <TextInput
                              style={[globalStyles.input, globalStyles.inputLight]}
                              value={props.values.itemizedDeductions}
                              keyboardType="numeric"
                              onChangeText={(text) => {
                                if (text === '' || /^\d+$/.test(text)) {
                                  props.handleChange('itemizedDeductions')(text)
                                }
                              }}
                            />

                            {props.touched.itemizedDeductions &&
                              props.errors.itemizedDeductions && (
                                <Text style={globalStyles.dangerAlert}>
                                  {props.errors.itemizedDeductions as string}
                                </Text>
                              )}
                          </View>
                        </View>


                        <View
                          style={[
                            globalStyles.hDirection,
                            globalStyles.hBetweenItems,
                            globalStyles.mb2
                          ]}
                        >
                          <View style={{ justifyContent: 'center', width: '68%' }}>
                            <Text
                              style={[
                                globalStyles.inputLabel,
                                globalStyles.inputLabelLarge,
                                globalStyles.inputLabelPrimary
                              ]}
                            >
                              {'Enter an estimate of your adjustments to income for the current year including alimony paid, IRA contributions, the pension exclusion and the exclusion for certain persons over 60 years old or disabled*'}
                            </Text>
                          </View>
                          <View style={{ width: '28%', overflow: 'hidden' }}>
                            <TextInput
                              style={[globalStyles.input, globalStyles.inputLight]}
                              value={props.values.alimonypaid}
                              keyboardType="numeric"
                              onChangeText={(text) => {
                                if (text === '' || /^\d+$/.test(text)) {
                                  props.handleChange('alimonypaid')(text)
                                }
                              }}
                            />

                            {props.touched.alimonypaid &&
                              props.errors.alimonypaid && (
                                <Text style={globalStyles.dangerAlert}>
                                  {props.errors.alimonypaid as string}
                                </Text>
                              )}
                          </View>
                        </View>


                        <View
                          style={[
                            globalStyles.hDirection,
                            globalStyles.hBetweenItems,
                            globalStyles.mb2
                          ]}
                        >
                          <View style={{ justifyContent: 'center', width: '68%' }}>
                            <Text
                              style={[
                                globalStyles.inputLabel,
                                globalStyles.inputLabelLarge,
                                globalStyles.inputLabelPrimary
                              ]}
                            >
                              {'Enter an estimate of your non-wage income for the current year*'}
                            </Text>
                          </View>
                          <View style={{ width: '28%', overflow: 'hidden' }}>
                            <TextInput
                              style={[globalStyles.input, globalStyles.inputLight]}
                              value={props.values.nonwageincome}
                              keyboardType="numeric"
                              onChangeText={(text) => {
                                if (text === '' || /^\d+$/.test(text)) {
                                  props.handleChange('nonwageincome')(text)
                                }
                              }}
                            />

                            {props.touched.nonwageincome &&
                              props.errors.nonwageincome && (
                                <Text style={globalStyles.dangerAlert}>
                                  {props.errors.nonwageincome as string}
                                </Text>
                              )}
                          </View>
                        </View>
                      </>
                    )}

                  </>

                }

                {(Number(props.values.residentornonresident) == 2) && <>

                  <View style={{ alignItems: 'center' }}>
                    <Text
                      style={[
                        globalStyles.text,
                        globalStyles.fwBold,
                        globalStyles.fs15,
                        globalStyles.blackTextColor
                      ]}
                    >
                      {'Non Resident Withholding Allowance(s)'}
                    </Text>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2,
                      { marginTop: 5 }
                    ]}
                  >
                    <View style={{ justifyContent: 'center', width: '68%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Select “1” for Yourself (2 if 60 years old or older) if no one else claims you as a dependent*'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title="Select “1” for Yourself (2 if 60 years old or older) if no one else claims you as a dependent"
                        options={options1}
                        selectedOption={mapSelectValue(
                          options1,
                          props.values.claimforyourself
                        )}
                        onSelect={(option: any) => {
                          props.setFieldValue('claimforyourself', option)
                        }}
                        textColor="primary"
                      />
                      {props.touched.claimforyourself &&
                        props.errors.claimforyourself && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.claimforyourself}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ justifyContent: 'center', width: '68%' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Select “1” for your Spouse (2 if 60 years old or older) if no one else claims your spouse as a dependent*'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <SelectKeyValue
                        title="Select “1” for your Spouse (2 if 60 years old or older) if no one else claims your spouse as a dependent"
                        options={options1}
                        selectedOption={mapSelectValue(
                          options1,
                          props.values.claimforspouse
                        )}
                        onSelect={(option: any) => {
                          props.setFieldValue('claimforspouse', option)
                        }}
                        textColor="primary"
                      />
                      {props.touched.claimforspouse &&
                        props.errors.claimforspouse && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.claimforspouse}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ width: '68%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Enter number of dependents other than your spouse that you will claim*'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.noofdependents}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('noofdependents')(text)
                          }
                        }}
                      />
                      {props.touched.noofdependents &&
                        props.errors.noofdependents && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.noofdependents}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View style={{ alignItems: 'center' }}>
                    <Text
                      style={[
                        globalStyles.text,
                        globalStyles.fwBold,
                        globalStyles.fs15,
                        globalStyles.blackTextColor
                      ]}
                    >
                      {'INCOME AND ADJUSTMENTS'}
                    </Text>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2, { marginTop: 5 }
                    ]}
                  >
                    <View style={{ width: '68%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Wages*'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.Wages}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('Wages')(text)
                          }
                        }}
                      />
                      {props.touched.Wages &&
                        props.errors.Wages && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.Wages}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ width: '68%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Non-wage Income (Net of Losses)*'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.nonwages}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('nonwages')(text)
                          }
                        }}
                      />
                      {props.touched.nonwages &&
                        props.errors.nonwages && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.nonwages}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2,
                    ]}
                  >
                    <View style={{ width: '68%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Federal Adjustments to Income *'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.federaladjustments}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('federaladjustments')(text)
                          }
                        }}
                      />
                      {props.touched.federaladjustments &&
                        props.errors.federaladjustments && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.federaladjustments}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2,
                    ]}
                  >
                    <View style={{ width: '68%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Delaware Adjustments to Income *'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.delwareadjustmensts}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('delwareadjustmensts')(text)
                          }
                        }}
                      />
                      {props.touched.delwareadjustmensts &&
                        props.errors.delwareadjustmensts && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.delwareadjustmensts}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View style={{ alignItems: 'center' }}>
                    <Text
                      style={[
                        globalStyles.text,
                        globalStyles.fwBold,
                        globalStyles.fs15,
                        globalStyles.blackTextColor
                      ]}
                    >
                      {'DEDUCTIONS'}
                    </Text>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2, { marginTop: 5 }
                    ]}
                  >
                    <View style={{ width: '68%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Deductions (Higher of Standard or Itemized)*'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.deductions}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('deductions')(text)
                          }
                        }}
                      />
                      {props.touched.deductions &&
                        props.errors.deductions && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.deductions}
                          </Text>
                        )}
                    </View>
                  </View>
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ width: '68%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Number of Pay Periods*'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.noofpayperiod}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('noofpayperiod')(text)
                          }
                        }}
                      />
                      {props.touched.noofpayperiod &&
                        props.errors.noofpayperiod && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.noofpayperiod}
                          </Text>
                        )}
                    </View>
                  </View>
                </>}





                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>
            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}
export default DeinformationForm
